<template>
  <van-tabbar
    style="border-top:1px solid #fafafa"
    v-if="show"
    v-model="active"
    @change="navBarChange"
  >
    <van-tabbar-item
      v-for="item in menus"
      :key="item.name"
      :name="item.name"
      :icon="item.meta.icon"
      >{{ item.meta.title }}</van-tabbar-item
    >
  </van-tabbar>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { Tabbar, TabbarItem } from "vant";
import { RouterMap } from "../router/router.config";
export default {
  name: "NavBar",
  components: {
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem,
  },

  data() {
    return {
      active: "",
      menus: [],
      show: true,
    };
  },
  computed: {
    ...mapState({
      navActive: state => state.app.navActive,
    }),
  },
  watch: {
    $route: {
      handler(val) {
        if (val.meta && !val.meta.showNavBar) {
          this.show = false;
        } else {
          this.show = true;
        }
        const matched = val.matched;
        let name = "home";
        if (matched.length > 1) {
          name = matched[1].name;
        }
        this.active = name;
        this.setNavActive(name);
      },
      immediate: true,
    },
  },
  created() {
    console.log(RouterMap);

    const menus = RouterMap.find(item => item.path === "/").children;
    this.menus = this.filterMenus(menus);
  },
  methods: {
    ...mapActions(["setNavActive"]),

    navBarChange(value) {
      this.$router.push({
        name: value,
      });
    },

    filterMenus(menus) {
      const newMenus = menus.filter(item => {
        if (item.meta && item.meta.show !== false) {
          return true;
        } else {
          return false;
        }
      });
      return newMenus;
    },
  },
};
</script>

<style lang="less"></style>
